import { render } from "./Repackage_list.vue?vue&type=template&id=bed08760&scoped=true"
import script from "./Repackage_list.vue?vue&type=script&lang=js"
export * from "./Repackage_list.vue?vue&type=script&lang=js"

import "./Repackage_list.vue?vue&type=style&index=0&id=bed08760&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bed08760"]])

export default __exports__